exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fbmgFYeENi2_gph5O8mp8{color:\"[theme:black, default:#000000]\";text-decoration:inherit}html[dir] .fbmgFYeENi2_gph5O8mp8{background-color:\"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] .fbmgFYeENi2_gph5O8mp8{padding:0 1px 0 2px}html[dir=rtl] .fbmgFYeENi2_gph5O8mp8{padding:0 2px 0 1px}", ""]);

// exports
exports.locals = {
	"mentions": "fbmgFYeENi2_gph5O8mp8"
};